import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Radio: ComponentStyleConfig = {
  baseStyle: {
    control: {
      display: 'inline-flex',
      alignItems: 'center',
      width: '24px',
      height: '24px',
      borderWidth: '1px',
      borderRadius: '5px',
      borderColor: 'neutral.600',
      background: 'white',
      _hover: {
        borderColor: 'black',
      },
      _checked: {
        borderColor: 'neutral.600',
        background: 'primary.500',
        _hover: {
          background: 'primary.500',
          borderColor: 'black',
        },
      },
    },
    label: {
      marginInlineStart: '8px',
      fontSize: 'md',
      lineHeight: '24px',
      fontWeight: 400,
      color: 'black',
    },
  },
};

export default Radio;
